import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { getAreasAlias, getIsAuthorsLoading } from 'core/selectors';
import { getAuthorsRequestAction } from 'core/actions';

import { AuthorsForm } from './Form';

interface IFormContainerProps {
  color?: string;
}

export const FormContainer = ({ color }: IFormContainerProps) => {
  const dispatch = useDispatch();
  const { area } = useParams<{ area?: string }>();
  const areasAlias = useSelector(getAreasAlias);

  const searchResultLoading = useSelector(getIsAuthorsLoading);

  const formOnSubmit = useCallback(() => {
    dispatch(getAuthorsRequestAction({ alias: area }));
  }, [dispatch, area]);

  return (
    <AuthorsForm
      handleSubmit={formOnSubmit}
      handleOnChange={formOnSubmit}
      loading={searchResultLoading}
      area={area}
      areasAlias={areasAlias}
      color={color}
    />
  );
};
